import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IOptionType } from 'interfaces/forms';

import { STATUS_OPTIONS } from 'components/BusinessToolForm/constants/options';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES}.${BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.R_AND_D}` as const;

export const TIMELINE_ROW_NAMES = {
  STAGE: 'stage',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  STATUS: 'status',
} as const;

export interface ITimelineRow {
  [TIMELINE_ROW_NAMES.STAGE]: string;
  [TIMELINE_ROW_NAMES.START_DATE]: string;
  [TIMELINE_ROW_NAMES.END_DATE]: string;
  [TIMELINE_ROW_NAMES.STATUS]: IOptionType | null;
}

export const timelineInitialValue = {
  [TIMELINE_ROW_NAMES.STAGE]: '',
  [TIMELINE_ROW_NAMES.START_DATE]: '',
  [TIMELINE_ROW_NAMES.END_DATE]: '',
  [TIMELINE_ROW_NAMES.STATUS]: STATUS_OPTIONS[0],
};

export const PRODUCTS_AND_SERVICES_R_AND_D_NAMES = {
  READINESS_LEVEL: 'readinessLevel',
  CONDUCTED_ACTIVITIES: 'conductedActivities',
  TIMELINES: 'timelines',
  RESOURCES: 'resources',
  WEAKNESSES: 'weaknesses',
} as const;

export interface IProductAndServicesRAndDForm {
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.READINESS_LEVEL]: string;
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.CONDUCTED_ACTIVITIES]: string;
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.TIMELINES]: ITimelineRow[];
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.RESOURCES]: string;
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.WEAKNESSES]: string;
}

export const productAndServicesRAndDInitialValues: IProductAndServicesRAndDForm = {
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.READINESS_LEVEL]: '',
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.CONDUCTED_ACTIVITIES]: '',
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.TIMELINES]: [timelineInitialValue],
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.RESOURCES]: '',
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.WEAKNESSES]: '',
};
